import { render, staticRenderFns } from "./VvDesktopTileList.vue?vue&type=template&id=8ce6775a&scoped=true&"
import script from "./VvDesktopTileList.vue?vue&type=script&lang=js&"
export * from "./VvDesktopTileList.vue?vue&type=script&lang=js&"
import style0 from "./VvDesktopTileList.vue?vue&type=style&index=0&id=8ce6775a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce6775a",
  null
  
)

export default component.exports